import { I18n } from '@/i18n/I18n';
import { useNavigate } from 'react-router-dom';
import { BasicButton } from '../components/buttons/BasicButton';
import { useGlobalStore } from '../store/GlobalStore';
import { FusawarePermission } from '../fusawareUser';

export function NotFoundWrapper(props: { children: React.ReactNode, permission: FusawarePermission }) {
  const { children, permission } = props;
  const userClass = useGlobalStore((state) => state.userClass);
  if (!userClass?.fusaHasPermission(permission)) {
    return <NotFound />;
  }
  return children;
}

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-vh-100 bg-light d-flex flex-column align-items-center justify-content-center p-4">
      <div className="d-flex flex-column align-items-center w-100" style={{ maxWidth: '600px', gap: '2rem' }}>
        <div className="bg-white rounded shadow-sm p-5 w-100 text-center">
          <div className="mb-4">
            <h1 className="display-1 fw-bold text-muted mb-3">404</h1>
            <h2 className="h4 fw-semibold mb-3">
              {I18n.get('pageNotFound')}
            </h2>
            <p className="text-muted mb-4">
              {I18n.get('pageNotFoundDescription')}
            </p>
          </div>
          <div className="d-flex justify-content-center gap-3">
            <BasicButton 
              onClick={() => navigate('/home')} 
              label={I18n.get('goToHome')} 
              className="btn btn-primary"
            />
            <BasicButton 
              onClick={() => navigate(-1)} 
              label={I18n.get('goBack')} 
              className="btn btn-outline-secondary"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
